import G from './Getters';
import { isCLI,isUsingWebdriver } from './versionConfig';
import Id, { Ids } from './IdFactory';
import C from './Constants';
import ActionCreators from './ActionCreators';


export default async function persistUnpersistedImageVersionsToCloud({imageId,delayStorage,args,dispatch,getState}){


  let fakeOrLocalStorage = ["local","fake"].includes(args.storageLocation);


  let isInTestEnvironment = false;
  if( process.env.NODE_ENV !== 'production' ){
    isInTestEnvironment = (
      isCLI() || isUsingWebdriver()
    )
  }



  let shouldNotReadOrStoreData = isInTestEnvironment && fakeOrLocalStorage && !args.readIntoMemory;
  let realDataToProcess = !shouldNotReadOrStoreData;


  let doNotStartCloudSync = !realDataToProcess && !delayStorage

  if( doNotStartCloudSync ){

    return dispatch({
      type:C.setRemoteStorageResourceId,
      _id:imageId,
      version:"raw", 
      storageLocation:args.storageLocation,
      pendingRecords:false,
      remoteStorageResourceId:Id(),
    })

  }else{


    let state = getState();

    let toSync = G.getUnpersistedImageVersionsNotCurrentlyBeingSynced(state,{imageId});


    console.error("SYNCING TO CLOUD STORAGE");


    return dispatch(
      ActionCreators.syncImagesToCloudStorage({
        toSync,
        storageLocation:args.storageLocation,
        args,
      })
    )

  }



}
